export default __webpack_public_path__ + "static/media/ruthlessassault.734911a0.png";